import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Hero } from '../components/home/Hero';
import { Principles } from '../components/home/Principles';
import { Steps } from '../components/home/Steps';
import { Transparency } from '../components/home/Transparency';
import { LabsPreview } from '../components/home/LabsPreview';
import { PharmacyPreview } from '../components/home/PharmacyPreview';
import { Testimonial } from '../components/home/Testimonial';
import { ProgramTable } from '../components/programs/ProgramTable';
import { SectionHeading } from '../components/ui/SectionHeading';
import { FaqList } from '../components/ui/FaqList';
import { CtaBand } from '../components/ui/CtaBand';
import { programs } from '../data/programs';
import { faqs } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { useBrand } from '../contexts/BrandContext';
export function Home() {
  const {
    brand
  } = useBrand();
  useDocumentMeta({
    title: brand.copy.metaTitle,
    description: brand.copy.metaDescription,
    image: brand.images.hero
  });
  return <main data-id="element-355" data-mp="2vyzzjt322nei">
      <Hero data-id="element-356" data-mp="2vy81mblzkdl2" />

      <section className="bg-cream-light" data-id="element-357" data-mp="2vvluue6x623w">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-358" data-mp="2qy2ftc2edlaw">
          <div className="flex flex-wrap items-end justify-between gap-8" data-id="element-359" data-mp="2mx0i4zo4phb1">
            <SectionHeading eyebrow="Programs" title="Six programs. One clinical standard." intro="Each program is a written protocol, a named pharmacy and a published price — not a catalogue of products." data-id="element-360" data-mp="2mz34n9q2osb0" />
            <Link to="/programs" className="group inline-flex items-center gap-2 pb-2 text-sm text-ink transition-colors duration-150 ease-republic hover:text-brick" data-id="element-361" data-mp="2895nveuh34vu">
              All programs
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-republic group-hover:translate-x-1" data-id="element-362" data-mp="1z9ikini6np05" />
            </Link>
          </div>
          <ProgramTable items={programs} data-id="element-363" data-mp="1kjnx39r1gfzm" />
        </div>
      </section>

      <Principles data-id="element-364" data-mp="1om2h3x6g1lsh" />
      <Steps data-id="element-365" data-mp="1omkjlbjp8w8u" />
      <Transparency data-id="element-366" data-mp="1on3rs0jjs69o" />
      <PharmacyPreview data-id="element-367" data-mp="1onnahjh0uyor" />
      <LabsPreview data-id="element-368" data-mp="1ojzjaqz1uod7" />
      <Testimonial data-id="element-369" data-mp="1an2ronb3x2v9" />

      <section className="bg-cream" data-id="element-370" data-mp="1ankuy3w6shco">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-371" data-mp="1aonneg95qrup">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-372" data-mp="1fmfghdljgk0h">
            <SectionHeading eyebrow="Questions" title="Answered plainly." data-id="element-373" data-mp="23ayods0oeus1" />
            <FaqList items={faqs} data-id="element-374" data-mp="28a1qp4p9umwb" />
          </div>
        </div>
      </section>

      <CtaBand data-id="element-375" data-mp="28c4erj6v65ye" />
    </main>;
}